// Versão única partilhada UI + API — incrementar a cada alteração (revision)
export const APP_VERSION = '2.0.10';
export const APP_REVISION = APP_VERSION;
